<template>
  <div @click="onClose" id="globalModal" class="wrapper" v-if="open">
    <div v-bind:class="{'global_modal wrapper_body card': true}" :style="{ width: modalWidth + '%' }">
      <div class="card-header" v-if="actualData?.headerText">
        <h4 class="m-0">{{ actualData.headerText }}</h4>
      </div>
      <div class="loading_div" v-if="loading">
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
      </div>
      <div v-if="!loading" class="modal_body card-body">
        <component
          :ref="`ref_${activeComponent}`"
          :is="activeComponent"
          :data="actualData"
          v-bind="actualData"
        />
        <div v-if="actualData.messageText" v-html="actualData.messageText"/>
      </div>
      <div class="card-footer flex justify-content-end">
        <button @click="onClose(null, true)" class="btn btn-default">Отмена</button>
        <LoadingButton
          v-if="extraBtnText"
          :title='extraBtnText'
          :loading="loadingButton"
          :onClick="() => save(true)"
          className="btn btn-outline-warning ml-1"
        />
        <LoadingButton
          :title='acceptBtnText'
          :loading="loadingButton"
          :onClick="() => save()"
          className="btn btn-success ml-1"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Agreement from '@/components/orders/Agreement/Body';
import LoadingButton from "@/components/buttons/LoadingButton"
import PhoneBlackListEditModal from '@/components/clients/PhoneBlackListEditModal'
import DeliveryDateChange from "@/components/orders/Agreement/DeliveryDateChange.vue";
import ShiftTaskActualDate from "@/views/statistics/components/ShiftTaskActualDate.vue";
import NoSupplierStatsTask from "@/views/statistics/components/NoSupplierStatsTask.vue";
import AddStatToBlackList from "@/views/statistics/components/AddStatToBlackList.vue";
import AddStatRecordToModeration from "@/views/statistics/components/AddStatRecordToModeration.vue";
import ConfirmCodeModal from "@/components/modals/ConfirmCodeModal.vue";
import UploadImagesWithPreview from "@/components/modals/UploadImagesWithPreview.vue";
import NewPostTrackNumber from "@/components/modals/NewPostTrackNumber.vue";
import store from "@/store";

export default {
  components: {
    Agreement,
    ShiftTaskActualDate,
    DeliveryDateChange,
    LoadingButton,
    PhoneBlackListEditModal,
    NoSupplierStatsTask,
    AddStatToBlackList,
    AddStatRecordToModeration,
    ConfirmCodeModal,
    UploadImagesWithPreview,
    NewPostTrackNumber,
  },
  data() {
    return {
      open: false,
      loading: true,
      loadingColor: this.$constants.LOADING_COLOR,
      activeComponent: null,
      actualData: null,
      acceptBtnText: 'OK',
      extraBtnText: null,
      loadingButton: false,
      modalWidth: 75,
    }
  },
  computed: {
    $GlobalModalData() {
      return this.$store.getters["platform/globalModalData"];
    },
  },
  watch: {
    '$GlobalModalData': {
      handler: function (val, oldVal) {
        if (!val) {
          this.onClose(null, true);
        } else {
          this.openModal(val);
        }
      },
      deep: true
    },
  },
  methods: {
    async openModal() {
      this.open = true;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "hidden";
      this.loading = true;
      this.modalWidth = 75;
      switch (this.$GlobalModalData.type) {
        case 'UploadImagesWithPreview':
          this.actualData = {
            ...this.$GlobalModalData,
          }
          this.activeComponent = this.$GlobalModalData.type;
          break;
        case 'NoSupplierStatsTask':
        case 'AddStatToBlackList':
        case 'ShiftTaskActualDate':
        case 'AddStatRecordToModeration':
        case 'ConfirmCodeModal':
        case 'NewPostTrackNumber':
          this.actualData = {
            ...this.$GlobalModalData,
          }
          this.modalWidth = 50;
          this.activeComponent = this.$GlobalModalData.type;
          break;
        case 'clientPhoneBlackList':
          this.actualData = {
            ...this.$GlobalModalData,
            test: 'ok'
          }
          this.activeComponent = 'PhoneBlackListEditModal';
          break;
        case 'DeliveryDateChange':
          this.modalWidth = 50;
          this.actualData = {
            ...this.$GlobalModalData,
            test: 'ok'
          }
          this.acceptBtnText = 'Сохранить';
          this.activeComponent = 'DeliveryDateChange';
          break;
        case 'newOrderAgreement':
          this.modalWidth = 50;
          this.actualData = {
            ...this.$GlobalModalData,
            test: 'ok'
          }
          this.extraBtnText = 'Отменить согласование'
          this.acceptBtnText = 'Согласовать';
          this.activeComponent = 'Agreement';
          break;
        default:
          if (this.$GlobalModalData.extraBtnText) this.extraBtnText = this.$GlobalModalData.extraBtnText;
          if (this.$GlobalModalData.acceptBtnText) this.acceptBtnText = this.$GlobalModalData.acceptBtnText;
          this.actualData = {...this.$GlobalModalData};
          break;
      }
      this.loading = false;
    },
    onClose(e, global = false) {
      if (global || (e && e.target && e.target.id === 'globalModal')) {
        // if (e.target.id === 'sideBarModalComponent') {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.open = false;
      }
    },
    async save(reject = false) {
      let res;
      switch (this.activeComponent) {
        case 'NewPostTrackNumber':
          res = await this.$refs[`ref_${this.activeComponent}`].saveData();
          if (res) {
            if (this.actualData.callBack) {
              await this.actualData.callBack();
              this.onClose(null, true);
            }
          }
          break;
        case 'ConfirmCodeModal':
          const validate = this.$refs[`ref_${this.activeComponent}`]?.validate();
          if (!validate) {
            toastr['warning']('Код не верный', 'Ошибка');
          } else {
            this.loadingButton = true;
            await this.actualData.callBack();
          }
          break;
        case 'AddStatToBlackList':
        case 'AddStatRecordToModeration':
        case 'UploadImagesWithPreview':
          this.loadingButton = true;
          const blRes = await this.$refs[`ref_${this.activeComponent}`]?.updateRecord();
          this.loadingButton = false;
          if (blRes.success) {
            toastr['success']('Сохранено!');
            if (this.actualData.callBack) {
              await this.actualData.callBack();
              this.onClose(null, true);
            }
          } else {
            toastr['warning'](blRes?.message || 'Ошибка!');
          }
          break;
        case 'PhoneBlackListEditModal':
          this.loadingButton = true;
          await this.$refs[`ref_${this.activeComponent}`].addToList();
          this.loadingButton = false;
          console.log('close');
          this.onClose(null, true);
          // store.dispatch("platform/setGlobalModalData", {});
          break;
        case 'DeliveryDateChange':
        case 'Agreement':
          this.loadingButton = true;
          const response = await this.$refs[`ref_${this.activeComponent}`].saveData(null, reject);
          if (response.success) {
            toastr['success']('Сохранено!');
            this.onClose(null, true);
          } else {
            toastr['warning'](response.message || 'Ошибка!');
          }
          this.loadingButton = false;
          break;
        case 'NoSupplierStatsTask':
          this.loadingButton = true;
          res = await this.$refs[`ref_${this.activeComponent}`]?.updateRecord();
          this.loadingButton = false;
          if (res) {
            if (this.actualData.callBack) {
              await this.actualData.callBack();
              this.onClose(null, true);
            }
          }
          break;
        default:
          if (this.actualData.callBack) {
            this.loadingButton = true;
            const res = await this.actualData.callBack(this.actualData.record, this.$refs[`ref_${this.activeComponent}`]?.getData());
            this.loadingButton = false;
            if (res) {
              this.onClose(null, true);
            }
          }
          if (!reject && this.actualData.accept) this.actualData.accept();
          if (reject && this.actualData.reject) this.actualData.reject();
          break;
      }
    }
  }
}
</script>

<style scoped>

.modal_body {
  padding: 50px;
  overflow-y: auto;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  background-color: white;
  width: 75%;
  min-height: 200px;
  margin: 50px auto;
  max-height: 75%;
  z-index: 9999;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 99999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

</style>

<style>
@media screen and (max-width: 720px) {
  .global_modal.wrapper_body {
    width: 95% !important;
  }
}
</style>
